import { DocumentNode, useApolloClient } from "@apollo/client";
import { useCallback } from "react";
import { getOperationFields } from "@ticketingplatform/api/dist/utils/apolloUtils";

const useEvictQueries = () => {
  const { cache } = useApolloClient();

  return useCallback(
    (queries: DocumentNode[]) => {
      queries.forEach((doc) =>
        getOperationFields(doc).forEach((fieldName: string) =>
          cache.evict({ fieldName })
        )
      );
    },
    [cache]
  );
};

export default useEvictQueries;
